export default import.meta.ROLLDOWN_FILE_URL_IBru0YaDkDIujHpESjTY9w